(function () {
    'use strict';

    class InteractiveCompletionController extends Controllers.BaseControllerES6 {

        // @ngInject
        constructor(
            $scope,
            $injector,
            UsersManager
        ) {
            super($scope, $injector);
            this.__objectType = 'InteractiveCompletionController';
            this.UsersManager = UsersManager;

            this.currUser = UsersManager.getCurrUser();
            this.firstName = this.currUser.first_name;
        }

        handleCloseMwebWizard() {
            this.completeMwebWizard();
        }

        handleContinueSetup() {
            this.completeWizard();
        }
    }

    Components.InteractiveCompletion = {
        controller: InteractiveCompletionController,
        bindings: {
            completeWizard: '&',
            completeMwebWizard: '&'
        },
        name: 'hbInteractiveCompletion',
        templateUrl: 'angular/app/modules/core/features/onboarding/interactive_onboarding/completion/completion.html',
    };
}());